/**
 * CompanySetupGate — управляет показом CompanySetupModal (1.32.0)
 *
 * Логика:
 *  • Если текущий пользователь — company_admin
 *  • И в company_details нет записи ИЛИ timezone пуст
 *  → показываем модалку.
 *
 * Модалка с allowSkip=true: админ может закрыть, тогда при следующем
 * входе она появится снова (пока не сохранит таймзону).
 *
 * Компонент рендерит null, если показывать нечего.
 */

import { useEffect, useState } from 'react';
import { useAuthStore } from '../domains/auth/authStore';
import { fetchCompanyDetails } from '../domains/companies/api';
import { CompanySetupModal } from './CompanySetupModal';

export function CompanySetupGate() {
  const user = useAuthStore((s) => s.user);
  const [needsSetup, setNeedsSetup] = useState(false);
  const [checked, setChecked] = useState(false);

  // Проверяем при каждой смене пользователя
  useEffect(() => {
    let cancelled = false;
    setChecked(false);
    setNeedsSetup(false);

    if (!user || user.role !== 'company_admin') {
      setChecked(true);
      return () => { cancelled = true; };
    }

    void (async () => {
      try {
        const details = await fetchCompanyDetails(user.company_id);
        if (cancelled) return;
        // Показываем, если записи нет или таймзона не заполнена
        setNeedsSetup(!details || !details.timezone);
      } catch {
        // Сеть могла упасть — не показываем модалку, чтобы не блокировать
        if (!cancelled) setNeedsSetup(false);
      } finally {
        if (!cancelled) setChecked(true);
      }
    })();

    return () => { cancelled = true; };
  }, [user?.id, user?.company_id, user?.role]);

  if (!checked || !needsSetup || !user) return null;

  return (
    <CompanySetupModal
      companyId={user.company_id}
      allowSkip={true}
      onClose={() => setNeedsSetup(false)}
      onSaved={() => setNeedsSetup(false)}
    />
  );
}
